import { rowCodecToFields, useQuery } from "../../../utils/supabase/useQuery";
import * as t from "io-ts";
import { sexCodec } from "../../../domain/user";
import { optionFromNullable } from "io-ts-types";
import { option } from "fp-ts";
import { flow, pipe } from "fp-ts/function";
import { Option } from "fp-ts/Option";
import * as React from "react";

const resultCodec = t.type(
    {
        id: t.string,
        race_number: t.string,
        name: t.string,
        born: t.number,
        sex: sexCodec,
        start: optionFromNullable(t.number),
        finish: optionFromNullable(t.number),
    },
    "Result"
);

export type Result = t.TypeOf<typeof resultCodec>;

export const useResults = () =>
    useQuery(
        "results",
        (supabase) =>
            supabase
                .from("bozi_vybeh_results")
                .select(rowCodecToFields(resultCodec)),
        t.array(resultCodec),
        {
            refreshInterval: 20,
        }
    );

export const formatTime = (time: Option<number>): string =>
    pipe(
        time,
        option.fold(() => "-", timeToStr)
    );

export const timeToStr = (time: number) => {
    const s = time % 60;
    const m = ((time % 3600) - s) / 60;
    const h = (time - s - m * 60) / 3600;

    return `${h}:${addLeadingZero(m)}:${addLeadingZero(s)}`;
};

const addLeadingZero = (m: number) => (m > 9 ? m : "0" + m);

export const strToTime = (str: string): Option<number> => {
    return pipe(
        str.match(/(\d{1,2}):([012345]\d):([012345]\d(,(\d+))?)/),
        option.fromNullable,
        option.map(
            flow(
                (matched) => {
                    return {
                        h: Number.parseInt(matched[1]),
                        m: Number.parseInt(matched[2]),
                        s: Number.parseFloat(matched[3]),
                    };
                },
                (segments) => {
                    return segments.h * 3600 + segments.m * 60 + segments.s;
                }
            )
        )
    );
};

// interface Props {
//     loading: boolean;
//     rows: Array<Result>;
// }

const ResultTable = () => {
    return (
        <div style={{ height: 400, width: "100%" }}>
            {/*<DataGrid*/}
            {/*    disableSelectionOnClick={true}*/}
            {/*    loading={props.loading}*/}
            {/*    rows={props.rows}*/}
            {/*    columns={columns}*/}
            {/*/>*/}
        </div>
    );
};

export default ResultTable;

// const columns: GridColDef[] = [
//     { field: "race_number", headerName: "číslo", type: "number", width: 60 },
//     { field: "name", headerName: "Jméno", width: 200 },
//     {
//         field: "category",
//         headerName: "Kategorie",
//         valueGetter: (params: GridValueGetterParams) => {
//             const born = params.row.born as number;
//             const sex = params.row.sex as Sex;
//             return category(sex, born);
//         },
//     },
//     {
//         field: "born",
//         headerName: "Ročník",
//     },
//     // {
//     //     field: "sex",
//     //     headerName: "Pohlaví",
//     //     valueFormatter: (params: GridValueGetterParams) =>
//     //         pipe(
//     //             record.lookup(String(params.value), sex),
//     //             option.fold(() => "X", identity)
//     //         ),
//     // },
//     {
//         field: "start",
//         headerName: "Start",
//         editable: true,
//         renderEditCell: renderRatingEditInputCell,
//         valueFormatter: (params: GridValueGetterParams) =>
//             formatTime(params.row.start),
//     },
//     {
//         field: "finish",
//         headerName: "Finish",
//         editable: true,
//         renderEditCell: renderRatingEditInputCell,
//         valueFormatter: (params: GridValueGetterParams) =>
//             formatTime(params.row.finish),
//     },
//     {
//         field: "time",
//         headerName: "čas",
//         valueGetter: (params: GridValueGetterParams) =>
//             pipe(
//                 sequenceT(option.option)(params.row.start, params.row.finish),
//                 option.map(([start, finish]) => {
//                     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//                     // @ts-ignore
//                     return finish - start;
//                 }),
//                 formatTime
//             ),
//     },
// ];

// function renderRatingEditInputCell(params) {
//     return <RatingEditInputCell {...params} />;
// }

// function RatingEditInputCell(props: GridCellParams) {
//     const { id, api, field } = props;
//     const supabase = useSupabase();
//
//     const origValue = pipe(
//         props.value,
//         option.fold(() => "", timeToStr)
//     );
//
//     const [value, setValue] = React.useState<string>(origValue);
//
//     React.useEffect(() => {
//         setValue(origValue);
//     }, [origValue]);
//
//     const handleBlur = (e) => {
//         const newValue = e.target.value;
//         setValue(newValue);
//
//         pipe(
//             newValue,
//             strToTime,
//             option.fold(constVoid, async (time) => {
//                 api.commitCellChange({
//                     id,
//                     field,
//                     props: {
//                         value: option.some(time),
//                     },
//                 });
//                 api.setCellMode(id, field, "view");
//
//                 await supabase
//                     .from("results")
//                     .update({ [field]: time })
//                     .eq("id", id);
//             })
//         );
//     };
//
//     return <input autoFocus value={value} onChange={handleBlur} />;
// }
